import {
  bindService,
  type AppFeatureDefinition,
  type ServiceBinding,
} from "@nasam/kernel";
import { rolesRepositoryToken } from "../../contracts";
import { createRolesHttpRepository } from "./data";
import { createRolesRoutes } from "./presentation/routes";
import { PERMISSION_MANAGEMENT_VIEW } from "./rolesPermissions";

export { rolesRepositoryToken };
export * from "./rolesPermissions";
function createRolesServiceBindings(
  httpClient: Parameters<
    NonNullable<AppFeatureDefinition["provideServices"]>
  >[0]["httpClient"],
): readonly ServiceBinding[] {
  return [
    bindService(rolesRepositoryToken, createRolesHttpRepository(httpClient)),
  ];
}

export const rolesFeature: AppFeatureDefinition = {
  id: "roles",
  version: "0.1.0",
  titleKey: "roles:moduleTitle",
  icon: "ShieldCheck",
  basePath: "/roles",
  requiredPermissions: [PERMISSION_MANAGEMENT_VIEW],
  // Every CORE feature shares one "core" rail node (see mergeFeatureNavNodes);
  // this feature contributes the "Roles" leaf under it.
  navigation: [
    {
      id: "core",
      titleKey: "common:businessModules.core",
      icon: "Layers",
      placement: "rail",
      order: 10,
      children: [
        {
          id: "roles",
          titleKey: "roles:moduleTitle",
          icon: "ShieldCheck",
          placement: "drawer",
          order: 30,
          path: "/roles",
          requiredPermissions: [PERMISSION_MANAGEMENT_VIEW],
        },
      ],
    },
  ],
  routes: (context) =>
    createRolesRoutes({
      context,
      roles: context.services.resolve(rolesRepositoryToken),
    }),
  i18n: {
    namespace: "roles",
    load: {
      en: () => import("../../i18n/locales/en/roles"),
      ar: () => import("../../i18n/locales/ar/roles"),
    },
  },
  permissionCatalog: [
    {
      segment: "core",
      labelKey: "roles:permissions.core",
      children: [
        {
          segment: "permission_management",
          labelKey: "roles:permissions.permissionManagement",
          children: [
            {
              segment: "permission_management_list",
              labelKey: "roles:permissions.roles",
              actions: [
                { id: "view", labelKey: "roles:actions.view" },
                { id: "create", labelKey: "roles:actions.create" },
                { id: "update", labelKey: "roles:actions.edit" },
                { id: "delete", labelKey: "roles:actions.delete" },
              ],
            },
          ],
        },
      ],
    },
  ],
  provideServices: ({ httpClient }) => createRolesServiceBindings(httpClient),
};
